import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/session';
interface AuthGuardProps {
  children: React.ReactNode;
}
export function AuthGuard({
  children
}: AuthGuardProps) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    // Check if the current path is a public route or login page
    const currentPath = location.pathname.toLowerCase();
    const isPublicRoute = currentPath.startsWith('/public');
    const isLoginPage = currentPath === '/login';
    // Skip authentication check for public routes and login page
    if (isPublicRoute || isLoginPage) {
      return;
    }
    // Check if user is authenticated
    if (!isAuthenticated()) {
      // Redirect to login page
      navigate('/login', {
        replace: true
      });
    }
  }, [location.pathname, navigate]);
  return <>{children}</>;
}